// Multi-language translations: ES (default), EN, FR, DE
export const translations = {
  es: {
    nav: {
      inicio: "Inicio",
      productos: "Productos",
      produccion: "Producción",
      logistica: "Logística",
      tienda: "Tienda",
      eventos: "Eventos",
      contacto: "Contacto",
      cart: "Carrito",
    },
    common: {
      since: "Desde 2005",
      learnMore: "Saber más",
      addToCart: "Añadir al carrito",
      viewAll: "Ver todo",
      readMore: "Leer más",
      backToTop: "Volver arriba",
      currency: "€",
    },
    home: {
      overline: "Producto Argentino · Hecho en España",
      title: "Sabor argentino,\nhecho a mano.",
      sub: "Desde 2005, compartimos los platos típicos de nuestra tierra con toda Europa. Elaboramos de forma propia nuestras empanadas, alfajores y chipás, combinando nuestra producción artesanal con la importación directa de productos argentinos seleccionados.",
      ctaPrimary: "Ver productos",
      ctaSecondary: "Nuestra producción",
      marquee: "TRADICIÓN ARGENTINA · CALIDAD DESDE 2005 · SABOR ARTESANAL · EMPANADA CRIOLLA · DULCE DE LECHE · ALFAJORES · VINOS ·",
      legacyOverline: "20 años de oficio",
      legacyTitle: "Un legado entre dos tierras.",
      legacyBody: "Nacimos en Argentina, crecimos en Europa. La Criollita es el resultado de combinar la receta de la abuela con el rigor de la industria alimentaria europea. Producimos, importamos y distribuimos productos alimenticios argentinos en España y la Unión Europea — con la marca registrada La Criollita.",
      bestsellersTitle: "Lo más pedido",
      bestsellersSub: "Nuestros clásicos, los favoritos de hoteles, restaurantes y familias en toda España.",
      ctaProductionTitle: "Detrás de cada bocado, una historia.",
      ctaProductionBody: "\u201CDescubre la artesanal elaboración en el amasado y relleno de cada pieza, con ingredientes seleccionados y procesos cuidados con esmero.\u201D",
      ctaProductionBtn: "Descubrir la producción",
      clientsOverline: "Empresas que confían en nosotros",
      clientsSub: "Distribuidores, retail y HORECA en España y Europa",
      stats: [
        { v: "20+", l: "Años de experiencia" },
        { v: "27", l: "Países UE alcanzados" },
        { v: "3", l: "Naciones en el equipo" },
        { v: "+50", l: "Referencias en catálogo" },
      ],
    },
    products: {
      overline: "Catálogo",
      title: "Nuestros productos.",
      sub: "Una selección de platos congelados, importaciones premium y delicatessen argentinas para el canal HORECA y para tu cocina.",
      filters: ["Todos", "Empanadas", "Dulces", "Salados", "Bebidas"],
    },
    production: {
      overline: "Cómo lo hacemos",
      title: "Del campo al horno,\nsin atajos.",
      sub: "Cada empanada nace de un proceso pensado en tres países: la receta de Argentina, el rigor francés y la cercanía española.",
      steps: [
        {
          t: "Masa amasada en casa",
          d: "Harina seleccionada, grasa vacuna o aceite vegetal, agua y sal. La hoja se estira fina, como manda la tradición.",
        },
        {
          t: "Relleno con producto noble",
          d: "Carne cortada a cuchillo, cebolla pochada lentamente, huevo, aceitunas y especias. Sin atajos industriales.",
        },
        {
          t: "Repulgue y congelado rápido",
          d: "Cada pieza se cierra a mano y se congela en blast freezer en menos de 90 minutos para conservar textura y sabor.",
        },
        {
          t: "Logística en frío hasta tu puerta",
          d: "Cadena de frío validada, packaging diseñado para HORECA y trazabilidad europea completa.",
        },
      ],
      ingredientsTitle: "Ingredientes de primera",
      ingredients: [
        { t: "Carne", d: "Cortada a cuchillo, jugosa y de origen trazado." },
        { t: "Cebolla", d: "Pochada lentamente, sin prisas, hasta dorar." },
        { t: "Aceitunas", d: "Verdes y enteras, intensas y mediterráneas." },
        { t: "Especias", d: "Comino, pimentón y pimienta — el alma criolla." },
      ],
    },
    logistics: {
      overline: "Distribución",
      title: "Llegamos a tu negocio.",
      sub: "Distribuimos a restaurantes, hoteles, tiendas gourmet y particulares en toda España y la Unión Europea, con cadena de frío validada.",
      nationalTitle: "España peninsular",
      nationalBody: "Entregas en 24–48h en frío negativo. Pedido mínimo profesional adaptado por zona.",
      euTitle: "Unión Europea",
      euBody: "Envíos consolidados a Francia, Alemania, Italia, Portugal, Países Bajos y Bélgica. Plazos 3–7 días según destino.",
      zonesTitle: "Zonas de cobertura",
      zones: [
        { z: "Madrid · Centro", d: "Lun–Sáb", w: "24h" },
        { z: "Cataluña", d: "Lun–Vie", w: "24–48h" },
        { z: "Andalucía", d: "Lun–Vie", w: "48h" },
        { z: "Valencia · Levante", d: "Lun–Vie", w: "48h" },
        { z: "Norte · País Vasco", d: "Lun–Vie", w: "48h" },
        { z: "Islas Baleares y Canarias", d: "Mar–Jue", w: "72h" },
        { z: "Francia · Bélgica", d: "Semanal", w: "3–5 días" },
        { z: "Alemania · Países Bajos", d: "Semanal", w: "4–7 días" },
      ],
      wholesaleCta: "¿Eres distribuidor o HORECA? Escríbenos para tarifas mayoristas.",
      wholesaleBtn: "Contactar comercial",
    },
    shop: {
      overline: "Tienda oficial",
      title: "Compra directa.",
      sub: "Añade tus favoritos al carrito y finaliza por WhatsApp o e-mail. Te confirmamos stock, fecha de entrega y forma de pago en menos de 24h.",
      empty: "Tu carrito está vacío.",
      cartTitle: "Tu pedido",
      subtotal: "Subtotal",
      checkoutWA: "Solicitar por WhatsApp",
      checkoutEmail: "Solicitar por e-mail",
      remove: "Quitar",
      added: "Añadido al carrito",
      qty: "Cantidad",
    },
    events: {
      overline: "Agenda",
      title: "Encuéntranos.",
      sub: "Ferias, catas y mercados gastronómicos donde podrás probar y comprar nuestros productos en directo.",
      viewDetails: "Ver detalles",
    },
    contact: {
      overline: "Hablemos",
      title: "Contacto.",
      sub: "Escríbenos y te responderemos en menos de 24 horas hábiles.",
      name: "Persona de contacto",
      company: "Empresa",
      activity: "Actividad",
      activityOptions: ["Distribuidor", "Supermercado", "HORECA", "Particular / Tienda"],
      email: "E-mail",
      phone: "Teléfono",
      subject: "Asunto",
      message: "Mensaje",
      send: "Enviar mensaje",
      sent: "¡Gracias! Hemos recibido tu mensaje.",
      addressTitle: "Dirección",
      address: "Mallorca · España",
      phoneTitle: "Teléfono",
      emailTitle: "E-mail",
      mapTitle: "Cómo llegar",
      mapSub: "Polígono Industrial de Marratxí",
      mapDirections: "Ver en Google Maps",
    },
    footer: {
      tagline: "Sabor artesanal argentino,\nhecho en España desde 2005",
      nav: "Navegación",
      contact: "Contacto",
      legal: "Legal",
      privacy: "Política de privacidad",
      terms: "Términos y condiciones",
      cookies: "Cookies",
      newsletter: "Recibe novedades y eventos",
      subscribe: "Suscribirme",
      placeholder: "tu@email.com",
      rights: "Todos los derechos reservados.",
    },
  },
  en: {
    nav: { inicio: "Home", productos: "Products", produccion: "Production", logistica: "Logistics", tienda: "Shop", eventos: "Events", contacto: "Contact", cart: "Cart" },
    common: { since: "Since 2005", learnMore: "Learn more", addToCart: "Add to cart", viewAll: "View all", readMore: "Read more", backToTop: "Back to top", currency: "€" },
    home: {
      overline: "Argentine craft · Made in Spain",
      title: "Argentine flavour,\nhandmade.",
      sub: "Since 2005, we have been sharing the traditional dishes of our land with the whole of Europe. We make our empanadas, alfajores and chipás in-house, combining our artisanal production with the direct import of selected Argentine products.",
      ctaPrimary: "Browse products",
      ctaSecondary: "Our production",
      marquee: "ARGENTINE TRADITION · QUALITY SINCE 2005 · ARTISAN FLAVOUR · CRIOLLA EMPANADA · DULCE DE LECHE · ALFAJORES · WINES ·",
      legacyOverline: "20 years of craft",
      legacyTitle: "A legacy between two lands.",
      legacyBody: "Born in Argentina, raised in Europe. La Criollita combines the grandmother's recipe with European food-industry standards. We produce, import and distribute Argentine food products in Spain and the EU under the registered La Criollita brand.",
      bestsellersTitle: "Most ordered",
      bestsellersSub: "Our classics — the favourites of hotels, restaurants and families across Spain.",
      ctaProductionTitle: "Behind every bite, a story.",
      ctaProductionBody: "\u201CDiscover the artisanal craft behind every piece — kneading, filling and shaping with selected ingredients and processes tended with care.\u201D",
      ctaProductionBtn: "Discover production",
      clientsOverline: "Companies that trust us",
      clientsSub: "Distributors, retail and HORECA in Spain and Europe",
      stats: [
        { v: "20+", l: "Years of expertise" },
        { v: "27", l: "EU countries reached" },
        { v: "3", l: "Nations on the team" },
        { v: "+50", l: "Catalogue references" },
      ],
    },
    products: {
      overline: "Catalogue",
      title: "Our products.",
      sub: "A selection of frozen dishes, premium imports and Argentine delicatessen for HORECA and your kitchen.",
      filters: ["All", "Empanadas", "Sweets", "Savoury", "Drinks"],
    },
    production: {
      overline: "How we make it",
      title: "From field to oven,\nno shortcuts.",
      sub: "Every empanada is born from a process imagined across three countries: the Argentine recipe, French rigour and Spanish closeness.",
      steps: [
        { t: "Dough kneaded in-house", d: "Selected flour, beef fat or vegetable oil, water and salt. The sheet is rolled thin, as tradition dictates." },
        { t: "Filled with noble produce", d: "Knife-cut beef, slowly stewed onion, egg, olives and spices. No industrial shortcuts." },
        { t: "Hand-sealed and flash-frozen", d: "Every piece is sealed by hand and blast-frozen in under 90 minutes to preserve texture and flavour." },
        { t: "Cold-chain logistics to your door", d: "Validated cold chain, HORECA-grade packaging and full European traceability." },
      ],
      ingredientsTitle: "First-rate ingredients",
      ingredients: [
        { t: "Beef", d: "Knife-cut, juicy, fully traced origin." },
        { t: "Onion", d: "Slowly stewed, no rush, until golden." },
        { t: "Olives", d: "Whole green olives, intense and Mediterranean." },
        { t: "Spices", d: "Cumin, paprika and pepper — the criollo soul." },
      ],
    },
    logistics: {
      overline: "Distribution",
      title: "We reach your business.",
      sub: "We distribute to restaurants, hotels, gourmet stores and private clients across Spain and the EU, with validated cold chain.",
      nationalTitle: "Mainland Spain",
      nationalBody: "Deliveries within 24–48h in negative cold. Minimum professional order adjusted per zone.",
      euTitle: "European Union",
      euBody: "Consolidated shipments to France, Germany, Italy, Portugal, the Netherlands and Belgium. Lead times 3–7 days depending on destination.",
      zonesTitle: "Coverage zones",
      zones: [
        { z: "Madrid · Centre", d: "Mon–Sat", w: "24h" },
        { z: "Catalonia", d: "Mon–Fri", w: "24–48h" },
        { z: "Andalusia", d: "Mon–Fri", w: "48h" },
        { z: "Valencia · Levante", d: "Mon–Fri", w: "48h" },
        { z: "North · Basque Country", d: "Mon–Fri", w: "48h" },
        { z: "Balearic & Canary Islands", d: "Tue–Thu", w: "72h" },
        { z: "France · Belgium", d: "Weekly", w: "3–5 days" },
        { z: "Germany · Netherlands", d: "Weekly", w: "4–7 days" },
      ],
      wholesaleCta: "Are you a distributor or HORECA? Reach out for wholesale prices.",
      wholesaleBtn: "Contact sales",
    },
    shop: {
      overline: "Official shop",
      title: "Direct order.",
      sub: "Add favourites to your cart and check out via WhatsApp or e-mail. We confirm stock, delivery date and payment within 24h.",
      empty: "Your cart is empty.",
      cartTitle: "Your order",
      subtotal: "Subtotal",
      checkoutWA: "Request via WhatsApp",
      checkoutEmail: "Request via e-mail",
      remove: "Remove",
      added: "Added to cart",
      qty: "Quantity",
    },
    events: {
      overline: "Agenda",
      title: "Find us.",
      sub: "Fairs, tastings and gourmet markets where you can try and buy our products live.",
      viewDetails: "View details",
    },
    contact: {
      overline: "Let's talk",
      title: "Contact.",
      sub: "Drop us a line — we answer in under 24 business hours.",
      name: "Contact person",
      company: "Company",
      activity: "Activity",
      activityOptions: ["Distributor", "Supermarket", "HORECA", "Private / Shop"],
      email: "E-mail",
      phone: "Phone",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      sent: "Thanks! We've received your message.",
      addressTitle: "Address",
      address: "Mallorca · Spain",
      phoneTitle: "Phone",
      emailTitle: "E-mail",
      mapTitle: "How to find us",
      mapSub: "Marratxí Industrial Park",
      mapDirections: "View on Google Maps",
    },
    footer: {
      tagline: "Argentine artisan flavour,\nmade in Spain since 2005",
      nav: "Navigation",
      contact: "Contact",
      legal: "Legal",
      privacy: "Privacy policy",
      terms: "Terms & conditions",
      cookies: "Cookies",
      newsletter: "Get news and events",
      subscribe: "Subscribe",
      placeholder: "you@email.com",
      rights: "All rights reserved.",
    },
  },
  fr: {
    nav: { inicio: "Accueil", productos: "Produits", produccion: "Production", logistica: "Logistique", tienda: "Boutique", eventos: "Événements", contacto: "Contact", cart: "Panier" },
    common: { since: "Depuis 2005", learnMore: "En savoir plus", addToCart: "Ajouter au panier", viewAll: "Tout voir", readMore: "Lire plus", backToTop: "Retour en haut", currency: "€" },
    home: {
      overline: "Artisanat argentin · Fabriqué en Espagne",
      title: "La saveur argentine,\nfaite main.",
      sub: "Depuis 2005, nous partageons les plats typiques de notre terre avec toute l'Europe. Nous élaborons nous-mêmes nos empanadas, alfajores et chipás, en associant notre production artisanale à l'importation directe de produits argentins sélectionnés.",
      ctaPrimary: "Voir les produits",
      ctaSecondary: "Notre production",
      marquee: "TRADITION ARGENTINE · QUALITÉ DEPUIS 2005 · SAVEUR ARTISANALE · EMPANADA CRIOLLA · DULCE DE LECHE · ALFAJORES · VINS ·",
      legacyOverline: "20 ans de métier",
      legacyTitle: "Un héritage entre deux terres.",
      legacyBody: "Née en Argentine, élevée en Europe. La Criollita allie la recette de la grand-mère à la rigueur de l'industrie alimentaire européenne. Nous produisons, importons et distribuons des produits alimentaires argentins en Espagne et dans l'UE sous la marque déposée La Criollita.",
      bestsellersTitle: "Les plus commandés",
      bestsellersSub: "Nos classiques — les favoris des hôtels, restaurants et familles de toute l'Espagne.",
      ctaProductionTitle: "Derrière chaque bouchée, une histoire.",
      ctaProductionBody: "\u00ABDécouvrez l\u2019élaboration artisanale dans le pétrissage et la garniture de chaque pièce, avec des ingrédients choisis et des procédés soignés avec amour.\u00BB",
      ctaProductionBtn: "Découvrir la production",
      clientsOverline: "Les entreprises qui nous font confiance",
      clientsSub: "Distributeurs, retail et restauration en Espagne et en Europe",
      stats: [
        { v: "20+", l: "Années d'expertise" },
        { v: "27", l: "Pays UE atteints" },
        { v: "3", l: "Nations dans l'équipe" },
        { v: "+50", l: "Références au catalogue" },
      ],
    },
    products: {
      overline: "Catalogue",
      title: "Nos produits.",
      sub: "Une sélection de plats surgelés, d'importations premium et d'épicerie fine argentine pour la restauration et votre cuisine.",
      filters: ["Tous", "Empanadas", "Douceurs", "Salés", "Boissons"],
    },
    production: {
      overline: "Comment nous le faisons",
      title: "Du champ au four,\nsans raccourcis.",
      sub: "Chaque empanada naît d'un procédé imaginé entre trois pays : la recette argentine, la rigueur française et la proximité espagnole.",
      steps: [
        { t: "Pâte pétrie maison", d: "Farine sélectionnée, graisse de bœuf ou huile végétale, eau et sel. La feuille est étalée finement, comme le veut la tradition." },
        { t: "Garnie de produits nobles", d: "Bœuf coupé au couteau, oignon mijoté, œuf, olives et épices. Aucun raccourci industriel." },
        { t: "Scellée à la main et surgelée", d: "Chaque pièce est scellée à la main et surgelée en moins de 90 minutes pour préserver texture et saveur." },
        { t: "Logistique en froid négatif", d: "Chaîne du froid validée, emballage HORECA et traçabilité européenne complète." },
      ],
      ingredientsTitle: "Des ingrédients d'exception",
      ingredients: [
        { t: "Bœuf", d: "Coupé au couteau, juteux, origine tracée." },
        { t: "Oignon", d: "Mijoté lentement, sans hâte, jusqu'à dorer." },
        { t: "Olives", d: "Olives vertes entières, intenses, méditerranéennes." },
        { t: "Épices", d: "Cumin, paprika et poivre — l'âme criolla." },
      ],
    },
    logistics: {
      overline: "Distribution",
      title: "Nous livrons votre entreprise.",
      sub: "Nous distribuons aux restaurants, hôtels, épiceries fines et particuliers en Espagne et UE, avec chaîne du froid validée.",
      nationalTitle: "Espagne péninsulaire",
      nationalBody: "Livraisons en 24–48h en froid négatif. Commande minimale professionnelle adaptée par zone.",
      euTitle: "Union Européenne",
      euBody: "Envois groupés vers France, Allemagne, Italie, Portugal, Pays-Bas et Belgique. Délais 3–7 jours selon destination.",
      zonesTitle: "Zones de couverture",
      zones: [
        { z: "Madrid · Centre", d: "Lun–Sam", w: "24h" },
        { z: "Catalogne", d: "Lun–Ven", w: "24–48h" },
        { z: "Andalousie", d: "Lun–Ven", w: "48h" },
        { z: "Valence · Levant", d: "Lun–Ven", w: "48h" },
        { z: "Nord · Pays Basque", d: "Lun–Ven", w: "48h" },
        { z: "Baléares & Canaries", d: "Mar–Jeu", w: "72h" },
        { z: "France · Belgique", d: "Hebdo.", w: "3–5 jours" },
        { z: "Allemagne · Pays-Bas", d: "Hebdo.", w: "4–7 jours" },
      ],
      wholesaleCta: "Vous êtes distributeur ou HORECA ? Contactez-nous pour les tarifs grossistes.",
      wholesaleBtn: "Contacter le commercial",
    },
    shop: {
      overline: "Boutique officielle",
      title: "Commande directe.",
      sub: "Ajoutez vos favoris au panier et finalisez par WhatsApp ou e-mail. Nous confirmons stock, livraison et paiement sous 24h.",
      empty: "Votre panier est vide.",
      cartTitle: "Votre commande",
      subtotal: "Sous-total",
      checkoutWA: "Demander par WhatsApp",
      checkoutEmail: "Demander par e-mail",
      remove: "Retirer",
      added: "Ajouté au panier",
      qty: "Quantité",
    },
    events: { overline: "Agenda", title: "Trouvez-nous.", sub: "Foires, dégustations et marchés gourmands où goûter et acheter nos produits en direct.", viewDetails: "Voir les détails" },
    contact: {
      overline: "Parlons-en", title: "Contact.",
      sub: "Écrivez-nous — réponse en moins de 24h ouvrées.",
      name: "Personne de contact", company: "Entreprise", activity: "Activité",
      activityOptions: ["Distributeur", "Supermarché", "HORECA", "Particulier / Boutique"],
      email: "E-mail", phone: "Téléphone", subject: "Sujet", message: "Message",
      send: "Envoyer le message", sent: "Merci ! Nous avons reçu votre message.",
      addressTitle: "Adresse", address: "Majorque · Espagne", phoneTitle: "Téléphone", emailTitle: "E-mail",
      mapTitle: "Comment nous trouver", mapSub: "Parc Industriel de Marratxí", mapDirections: "Voir sur Google Maps",
    },
    footer: {
      tagline: "Saveur artisanale argentine,\nfaite en Espagne depuis 2005",
      nav: "Navigation", contact: "Contact", legal: "Légal",
      privacy: "Politique de confidentialité", terms: "Conditions générales", cookies: "Cookies",
      newsletter: "Recevez nos actualités et événements", subscribe: "S'abonner", placeholder: "vous@email.com",
      rights: "Tous droits réservés.",
    },
  },
  de: {
    nav: { inicio: "Start", productos: "Produkte", produccion: "Produktion", logistica: "Logistik", tienda: "Shop", eventos: "Events", contacto: "Kontakt", cart: "Warenkorb" },
    common: { since: "Seit 2005", learnMore: "Mehr erfahren", addToCart: "In den Warenkorb", viewAll: "Alle ansehen", readMore: "Weiterlesen", backToTop: "Nach oben", currency: "€" },
    home: {
      overline: "Argentinisches Handwerk · Hergestellt in Spanien",
      title: "Argentinischer Geschmack,\nvon Hand gemacht.",
      sub: "Seit 2005 teilen wir die traditionellen Gerichte unseres Landes mit ganz Europa. Unsere Empanadas, Alfajores und Chipás stellen wir selbst her und verbinden unsere handwerkliche Produktion mit dem Direktimport ausgewählter argentinischer Produkte.",
      ctaPrimary: "Produkte ansehen",
      ctaSecondary: "Unsere Produktion",
      marquee: "ARGENTINISCHE TRADITION · QUALITÄT SEIT 2005 · HANDWERKLICHER GESCHMACK · CRIOLLA EMPANADA · DULCE DE LECHE · ALFAJORES · WEINE ·",
      legacyOverline: "20 Jahre Handwerk",
      legacyTitle: "Ein Erbe zwischen zwei Welten.",
      legacyBody: "Geboren in Argentinien, gewachsen in Europa. La Criollita verbindet das Rezept der Großmutter mit europäischen Lebensmittelstandards. Wir produzieren, importieren und vertreiben argentinische Lebensmittel in Spanien und der EU unter der Marke La Criollita.",
      bestsellersTitle: "Am meisten bestellt",
      bestsellersSub: "Unsere Klassiker — Favoriten von Hotels, Restaurants und Familien in ganz Spanien.",
      ctaProductionTitle: "Hinter jedem Bissen eine Geschichte.",
      ctaProductionBody: "\u201EEntdecken Sie die handwerkliche Herstellung beim Kneten und Füllen jedes Stücks, mit ausgewählten Zutaten und sorgfältigen Prozessen.\u201C",
      ctaProductionBtn: "Produktion entdecken",
      clientsOverline: "Unternehmen, die uns vertrauen",
      clientsSub: "Vertrieb, Einzelhandel und Gastronomie in Spanien und Europa",
      stats: [
        { v: "20+", l: "Jahre Erfahrung" },
        { v: "27", l: "Erreichte EU-Länder" },
        { v: "3", l: "Nationen im Team" },
        { v: "+50", l: "Katalogreferenzen" },
      ],
    },
    products: {
      overline: "Katalog",
      title: "Unsere Produkte.",
      sub: "Eine Auswahl an Tiefkühlgerichten, Premium-Importen und argentinischen Delikatessen für die Gastronomie und Ihre Küche.",
      filters: ["Alle", "Empanadas", "Süßes", "Alfajores", "Chipás"],
    },
    production: {
      overline: "Wie wir es machen",
      title: "Vom Feld in den Ofen,\nohne Abkürzungen.",
      sub: "Jede Empanada entsteht in einem Prozess, der in drei Ländern gedacht wurde: argentinisches Rezept, französische Strenge und spanische Nähe.",
      steps: [
        { t: "Hausgemachter Teig", d: "Ausgewähltes Mehl, Rinderfett oder Pflanzenöl, Wasser und Salz. Das Blatt wird dünn ausgerollt — wie es die Tradition verlangt." },
        { t: "Edel gefüllt", d: "Mit dem Messer geschnittenes Rindfleisch, langsam gedünstete Zwiebel, Ei, Oliven und Gewürze. Keine industriellen Abkürzungen." },
        { t: "Handverschlossen und schockgefroren", d: "Jedes Stück wird von Hand verschlossen und in unter 90 Minuten schockgefroren — Textur und Geschmack bleiben erhalten." },
        { t: "Kühlkette bis zur Tür", d: "Validierte Kühlkette, HORECA-Verpackung und vollständige europäische Rückverfolgbarkeit." },
      ],
      ingredientsTitle: "Erstklassige Zutaten",
      ingredients: [
        { t: "Rind", d: "Mit dem Messer geschnitten, saftig, rückverfolgbar." },
        { t: "Zwiebel", d: "Langsam gedünstet bis goldbraun." },
        { t: "Oliven", d: "Ganze grüne Oliven, intensiv und mediterran." },
        { t: "Gewürze", d: "Kreuzkümmel, Paprika und Pfeffer — die criollo-Seele." },
      ],
    },
    logistics: {
      overline: "Vertrieb",
      title: "Wir erreichen Ihr Geschäft.",
      sub: "Wir beliefern Restaurants, Hotels, Feinkostgeschäfte und Privatkunden in ganz Spanien und der EU mit validierter Kühlkette.",
      nationalTitle: "Festland-Spanien",
      nationalBody: "Lieferungen in 24–48h tiefgekühlt. Mindestbestellmenge je nach Zone angepasst.",
      euTitle: "Europäische Union",
      euBody: "Sammelsendungen nach Frankreich, Deutschland, Italien, Portugal, Niederlande und Belgien. Laufzeit 3–7 Tage je nach Ziel.",
      zonesTitle: "Liefergebiete",
      zones: [
        { z: "Madrid · Zentrum", d: "Mo–Sa", w: "24h" },
        { z: "Katalonien", d: "Mo–Fr", w: "24–48h" },
        { z: "Andalusien", d: "Mo–Fr", w: "48h" },
        { z: "Valencia · Levante", d: "Mo–Fr", w: "48h" },
        { z: "Norden · Baskenland", d: "Mo–Fr", w: "48h" },
        { z: "Balearen & Kanaren", d: "Di–Do", w: "72h" },
        { z: "Frankreich · Belgien", d: "Wöchentl.", w: "3–5 Tage" },
        { z: "Deutschland · Niederlande", d: "Wöchentl.", w: "4–7 Tage" },
      ],
      wholesaleCta: "Distributor oder HORECA? Kontaktieren Sie uns für Großhandelspreise.",
      wholesaleBtn: "Vertrieb kontaktieren",
    },
    shop: {
      overline: "Offizieller Shop",
      title: "Direkt bestellen.",
      sub: "Fügen Sie Favoriten zum Warenkorb hinzu und schließen Sie per WhatsApp oder E-Mail ab. Bestätigung von Bestand, Lieferung und Zahlung in 24h.",
      empty: "Ihr Warenkorb ist leer.",
      cartTitle: "Ihre Bestellung",
      subtotal: "Zwischensumme",
      checkoutWA: "Anfrage per WhatsApp",
      checkoutEmail: "Anfrage per E-Mail",
      remove: "Entfernen",
      added: "Zum Warenkorb hinzugefügt",
      qty: "Menge",
    },
    events: { overline: "Agenda", title: "Finden Sie uns.", sub: "Messen, Verkostungen und Feinschmeckermärkte, auf denen Sie unsere Produkte probieren und kaufen können.", viewDetails: "Details ansehen" },
    contact: {
      overline: "Sprechen wir", title: "Kontakt.",
      sub: "Schreiben Sie uns — Antwort innerhalb von 24 Werktagsstunden.",
      name: "Ansprechpartner", company: "Unternehmen", activity: "Tätigkeit",
      activityOptions: ["Distributor", "Supermarkt", "HORECA", "Privat / Laden"],
      email: "E-Mail", phone: "Telefon", subject: "Betreff", message: "Nachricht",
      send: "Nachricht senden", sent: "Danke! Wir haben Ihre Nachricht erhalten.",
      addressTitle: "Adresse", address: "Mallorca · Spanien", phoneTitle: "Telefon", emailTitle: "E-Mail",
      mapTitle: "So finden Sie uns", mapSub: "Industriegebiet Marratxí", mapDirections: "Auf Google Maps anzeigen",
    },
    footer: {
      tagline: "Argentinischer handwerklicher Geschmack,\nhergestellt in Spanien seit 2005",
      nav: "Navigation", contact: "Kontakt", legal: "Rechtliches",
      privacy: "Datenschutzerklärung", terms: "AGB", cookies: "Cookies",
      newsletter: "Neuigkeiten und Events erhalten", subscribe: "Abonnieren", placeholder: "sie@email.com",
      rights: "Alle Rechte vorbehalten.",
    },
  },
};

export const LANGS = [
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
  { code: "de", label: "DE" },
];
